module.exports = __webpack_public_path__ + "img/logo-en.d92329ab.png";